import { X } from 'lucide-react';
import { formatCurrency } from '@lancar-pos/shared';
import type { ProductVariant } from '@lancar-pos/db-schema';

interface VariantSelectorProps {
  productName: string;
  basePrice: number;
  variants: ProductVariant[];
  onSelect: (variant: ProductVariant) => void;
  onClose: () => void;
}

export function VariantSelector({
  productName,
  basePrice,
  variants,
  onSelect,
  onClose,
}: VariantSelectorProps) {
  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-xl z-50 w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Pilih Varian</h2>
            <p className="text-sm text-gray-500">{productName}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="space-y-2 max-h-80 overflow-y-auto">
          {variants
            .filter((v) => v.isActive)
            .map((variant) => {
              const finalPrice = basePrice + variant.priceModifier;
              const isOutOfStock = variant.stock <= 0;

              return (
                <button
                  key={variant.id}
                  onClick={() => !isOutOfStock && onSelect(variant)}
                  disabled={isOutOfStock}
                  className={`
                    w-full p-4 rounded-lg border-2 text-left transition-all
                    ${isOutOfStock
                      ? 'border-gray-100 bg-gray-50 opacity-50 cursor-not-allowed'
                      : 'border-gray-200 hover:border-primary-500 hover:bg-primary-50 active:scale-[0.99]'
                    }
                  `}
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-medium text-gray-900">{variant.name}</p>
                      <p className="text-sm text-gray-500">SKU: {variant.sku}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-primary-600">
                        {formatCurrency(finalPrice)}
                      </p>
                      <p className={`text-xs ${isOutOfStock ? 'text-red-500' : 'text-gray-400'}`}>
                        {isOutOfStock ? 'Habis' : `Stok: ${variant.stock}`}
                      </p>
                    </div>
                  </div>
                </button>
              );
            })}
        </div>

        <p className="text-xs text-gray-400 mt-4 text-center">
          Klik varian untuk menambahkan ke keranjang
        </p>
      </div>
    </>
  );
}
